export const chartColors = [
    'var(--chart-series-1-standard)',
    'var(--chart-series-2-standard)',
    'var(--chart-series-3-standard)',
    'var(--chart-series-4-standard)',
    'var(--chart-series-5-standard)',
    'var(--chart-series-6-standard)',
    'var(--chart-series-7-standard)',
    'var(--chart-series-8-standard)',
    'var(--chart-series-9-standard)',
    'var(--chart-series-10-standard)',
];

export const lightChartColors = [
    'var(--chart-series-1-subdued)',
    'var(--chart-series-2-subdued)',
    'var(--chart-series-3-subdued)',
    'var(--chart-series-4-subdued)',
    'var(--chart-series-5-subdued)',
    'var(--chart-series-6-subdued)',
    'var(--chart-series-7-subdued)',
    'var(--chart-series-8-subdued)',
    'var(--chart-series-9-subdued)',
    'var(--chart-series-10-subdued)',
];

export const chartColorSets = chartColors.map((color, index) => ({
    primary: color,
    light: lightChartColors[index],
}));

export const RETENTION_BENCHMARK_CONSTANTS = {
    best: {
        border: 'var(--chart-retention-best-stroke-base)',
        hover: 'var(--chart-retention-best-stroke-hover)',
        percentile: '90th',
    },
    good: {
        border: 'var(--chart-retention-good-stroke-base)',
        hover: 'var(--chart-retention-good-stroke-hover)',
        percentile: '75th',
    },
    median: {
        border: 'var(--chart-retention-median-stroke-base)',
        hover: 'var(--chart-retention-median-stroke-hover)',
        percentile: '50th',
    },
    low: {
        border: 'var(--chart-retention-low-stroke-base)',
        hover: 'var(--chart-retention-low-stroke-hover)',
        percentile: '25th',
    },
};

const FUNNEL_CHART_HOVER_COLORS = [
    'var(--chart-series-1-hover)',
    'var(--chart-series-2-hover)',
    'var(--chart-series-3-hover)',
    'var(--chart-series-4-hover)',
    'var(--chart-series-5-hover)',
    'var(--chart-series-6-hover)',
    'var(--chart-series-7-hover)',
    'var(--chart-series-8-hover)',
    'var(--chart-series-9-hover)',
    'var(--chart-series-10-hover)',
];

const FUNNEL_CHART_DROPPED_HOVER_COLORS = [
    'var(--chart-series-1-subdued-hover)',
    'var(--chart-series-2-subdued-hover)',
    'var(--chart-series-3-subdued-hover)',
    'var(--chart-series-4-subdued-hover)',
    'var(--chart-series-5-subdued-hover)',
    'var(--chart-series-6-subdued-hover)',
    'var(--chart-series-7-subdued-hover)',
    'var(--chart-series-8-subdued-hover)',
    'var(--chart-series-9-subdued-hover)',
    'var(--chart-series-10-subdued-hover)',
];

export const FUNNEL_CHART_COLORS = {
    continued: chartColors,
    dropped: lightChartColors,
    hover: FUNNEL_CHART_HOVER_COLORS,
    droppedHover: FUNNEL_CHART_DROPPED_HOVER_COLORS,
    selected: FUNNEL_CHART_HOVER_COLORS,
    droppedSelected: FUNNEL_CHART_DROPPED_HOVER_COLORS,
};

export const GOAL_CHART_COLORS = {
    data: 'var(--chart-goal-data-base)',
    baseline: 'var(--chart-goal-baseline-base)',
    target: 'var(--chart-goal-target-base)',
};

export const LISTEN_CHART_COLORS = [
    'var(--chart-listen-series-1-base)',
    'var(--chart-listen-series-2-base)',
    'var(--chart-listen-series-3-base)',
    'var(--chart-listen-series-4-base)',
    'var(--chart-listen-series-5-base)',
];

export const USER_FREQUENCY_CHART_COLORS = [
    'var(--chart-user-frequency-series-1-base)',
    'var(--chart-user-frequency-series-2-base)',
    'var(--chart-user-frequency-series-3-base)',
];

export const PEOPLE_DWM_CHART_COLORS = [
    'var(--chart-people-dwm-series-1-base)',
    'var(--chart-people-dwm-series-2-base)',
    'var(--chart-people-dwm-series-3-base)',
];

export const WORKFLOW_TOTALS_CHART_COLORS = [
    'var(--chart-workflow-totals-series-1-base)',
    'var(--chart-workflow-totals-series-2-base)',
    'var(--chart-workflow-totals-series-3-base)',
];

export const NPS_COLOR_MAP = {
    detractors: 'var(--chart-nps-detractor-base)',
    passive: 'var(--chart-nps-passive-base)',
    promoters: 'var(--chart-nps-promoter-base)',
};

export default chartColors;
